import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { generateBemCss } from 'general/js/helpers';
import { SchemaOrg } from 'project/schema-org';
import { ContentType } from 'components/content-type';
import endeavorPlayerModal from '../../endeavor-player-modal/js/endeavor-player-modal';
import { getVideoMetadataAsync } from '../../../general/js/api/endeavor/services/vod-service';

const MediaVideoPlayerPost = ({ model, targetUrl }) => {
    const bemCss = generateBemCss('media-post', [model.type]);
    const url = targetUrl ? `${targetUrl}?popupVideoId=${model.videoId}` : null;
    const [endeavorMetadata, setEndeavorMetadata] = useState({ isEmpty: true });

    useEffect(() => {
        if (!model.videoId) {
            return;
        }
        getVideoMetadataAsync({ videoId: model.videoId })
            .then((response) => {
                setEndeavorMetadata(response.metadata);
            });
    }, [model.videoId]);

    const content = {
        videoId: model.videoId,
        hideCover: true,
        autoplay: true,
        coverImageAdditionalClass: 'relative'
    };

    const onClickRoot = () => {
        if (targetUrl) return;
        const options = {
            propsMetadata: endeavorMetadata,
            content
        };
        endeavorPlayerModal.show(model.videoId, options);
    };

    return endeavorMetadata.isEmpty ? null : (
        <a
            className={bemCss}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClickRoot}
        >
            <div className="media-post__content-type">
                <ContentType type={model.type} />
            </div>
            <div className="media-post__bg">

                <img
                    key={model.overrideSrc || endeavorMetadata.thumbnailSrc}
                    className="lazyload"
                    data-srcset={model.overrideSrc || endeavorMetadata.thumbnailSrc}
                    alt=""
                />
            </div>
            <div className="media-post__content">
                <h3 className="medial-post__title">{model.title}</h3>
                {
                    model.body &&
                    <div
                        className="media-post__body"
                        dangerouslySetInnerHTML={{ __html: model.body }}
                    />
                }
            </div>
            <SchemaOrg model={model.schemaOrg} />
        </a>
    );
};

MediaVideoPlayerPost.propTypes = {
    model: PropTypes.object.isRequired,
};

export default MediaVideoPlayerPost;
